//页面权限配置
export default {
    namespaced: true,
    state: {
        datas:{}
    },
    getters: {
        
    },
    actions: {
        set ({ state, dispatch }, dbList) {
            return new Promise(async resolve => {
                // store 赋值
                if(dbList && dbList.length>0){

                    dbList.forEach(row => {
                        let busKey = row.busKey;
                        let tablePermission = row.tablePermission;
                        if(tablePermission){
                            tablePermission = JSON.parse(tablePermission);
                        }
                        let permission = row.permission;
                        if(permission){
                            permission = JSON.parse(permission);
                        }
                        state.datas[busKey] = {
                            tablePermission:tablePermission,
                            permission:permission
                        }
                    });
                }else{
                    state.datas = {};
                }

                // 持久化
                await dispatch('admin/db/set', {
                    dbName: 'sys',
                    path: 'pageAuthConfig.datas',
                    value: state.datas,
                    user: true
                }, { root: true });

                // end
                resolve();
            })
        },
        load ({ state, dispatch }) {
            return new Promise(async resolve => {
                // store 赋值
                state.datas = await dispatch('admin/db/get', {
                    dbName: 'sys',
                    path: 'pageAuthConfig.datas',
                    defaultValue: {},
                    user: true
                }, { root: true });
                // end
                resolve();
            })
        }
    },
    mutations: {
        setDatas (state, dbList) {
            if(dbList && dbList.length>0){
                dbList.forEach(row => {
                    let busKey = row.busKey;
                    let tablePermission = row.tablePermission;
                    if(tablePermission){
                        tablePermission = JSON.parse(tablePermission);
                    }
                    let permission = row.permission;
                    if(permission){
                        permission = JSON.parse(permission);
                    }
                    state.datas[busKey] = {
                        tablePermission:tablePermission,
                        permission:permission
                    }
                });
            }
        },
    }
}
